import * as React from 'react';
import { View, createView } from '../view';
/** @deprecated */ export function createStyled(deprecatedCss) {
    return new Proxy({}, {
        // Performance: Use 'div' instead of adding a generic argument that extends
        // IntrinsicElement to prevent TypeScript from checking this method with
        // every intrinsic element. This speeds up type-checking by several seconds.
        get (_target, tag) {
            return (declarations, ...args)=>{
                const styles = deprecatedCss(declarations, ...args);
                return createView(/* @ts-expect-error downcasting */ (props)=>/*#__PURE__*/ React.createElement(View, {
                        uses: [
                            props,
                            styles
                        ]
                    }), tag);
            };
        }
    });
}

//# sourceMappingURL=createStyled.js.map